export const yesNoQuestion = [
  'Yes',
  'No',
];
export const EMAIL_REGEX = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
// export const PHONE_REGEX = /^((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}$/;
export const PHONE_REGEX = /^\(\d\d\d\)\s\d\d\d-\d\d\d\d/;

export const CREDIT_SCORES = ['780+', '760-779', '740-759', '720-739', '700-719', '680-699', '660-679', '620-659', 'Below 620', "I'm not sure"];
